import { API_BASE_URL } from '@utils/constants/app-constants.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { DateRangeParams } from '@utils/types/resellers/dashboard.ts';

/**
 * Downloads the Excel report for reseller data
 * This is not a React Query hook since it triggers a download
 */
export const downloadResellerReport = async (
  dateRange?: DateRangeParams
): Promise<void> => {
  const params = new URLSearchParams();

  if (dateRange?.periodStart) {
    params.append('period_start', dateRange.periodStart);
  }
  if (dateRange?.periodEnd) {
    params.append('period_end', dateRange.periodEnd);
  }

  const token = TokenExtension.get().string;
  const queryString = params.toString();
  const url = `${API_BASE_URL}/api/v3/reseller/reporting/export${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = 'Failed to download report';
    try {
      const errorData = JSON.parse(errorText);
      errorMessage =
        errorData.error_description ||
        errorData.detail ||
        errorData.error ||
        errorData.message ||
        errorMessage;
    } catch {
      // If parsing fails, use default error message
    }
    throw new Error(errorMessage);
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', '');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};
